import { useDispatch, useSelector } from 'react-redux';
import { useCallback } from 'react';
import { RootState, AppDispatch } from '../redux/store';
import {
  getCurrentUserBalance,
  getTransactionHistory,
  convertToUsdb,
  useServicePoints as servicePoints,
  creditVolunteerHours,
  validateSocialImpactNumber,
  clearErrors
} from '../redux/rewardsSlice';

export const useRewards = () => {
  const dispatch = useDispatch<AppDispatch>();
  const rewardsState = useSelector((state: RootState) => state.rewards);

  const fetchBalance = useCallback(() => {
    return dispatch(getCurrentUserBalance());
  }, [dispatch]);

  const fetchTransactionHistory = useCallback(() => {
    return dispatch(getTransactionHistory());
  }, [dispatch]);

  const convertPointsToUsdb = useCallback((amount: number) => {
    return dispatch(convertToUsdb({ amount }));
  }, [dispatch]);

  const payWithServicePoints = useCallback((amount: number, charityOrganizationId: number, serviceDescription: string) => {
    return dispatch(servicePoints({ amount, charityOrganizationId, serviceDescription }));
  }, [dispatch]);

  const creditVolunteerTime = useCallback((socialImpactNumber: string, hours: number, organizationName: string) => {
    return dispatch(creditVolunteerHours({ socialImpactNumber, hours, organizationName }));
  }, [dispatch]);

  const validateSocialImpact = useCallback((socialImpactNumber: string) => {
    return dispatch(validateSocialImpactNumber(socialImpactNumber));
  }, [dispatch]);

  const resetErrors = useCallback(() => {
    dispatch(clearErrors());
  }, [dispatch]);

  return {
    ...rewardsState,
    fetchBalance,
    fetchTransactionHistory,
    convertPointsToUsdb,
    payWithServicePoints,
    creditVolunteerTime,
    validateSocialImpact,
    resetErrors,
  };
};